import { z } from "zod";

/** ******************************************************************************
 *  Types
 ******************************************************************************* */

const TransactionStatusEnum = z.enum(["PENDING", "REVERSED", "FINAL"]);

const TransactionTypeEnum = z.enum([
  "USER_REGISTRATION_ALLOWANCE",
  "TEAM_REGISTRATION_ALLOWANCE",
  "TOKENS_PURCHASED",
  "INFERENCE_ESCROW",
  "INFERENCE_ESCROW_REFUND",
  "INFERENCE_SPEND",
  "INFERENCE_PAYMENT",
]);

export const TransactionSchema = z.object({
  _id: z.string(),
  teamId: z.string(),
  userId: z.string().nullish(),
  apiKeyId: z.string().nullish(),
  workerId: z.string().nullish(),
  generationId: z.string().nullish(),
  status: TransactionStatusEnum,
  type: TransactionTypeEnum,
  points: z.number(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export type Transaction = z.infer<typeof TransactionSchema>;
